import notEmpty from 'lib/validator/notEmpty'
import notEmptyAttribute from 'lib/validator/notEmptyAttribute'
import minLength from 'lib/validator/minLength'
import isJSON from 'lib/validator/isJSON'
import isEmail from 'lib/validator/isEmail'
import isPhoneNumber from 'lib/validator/isPhoneNumber'
import isTimeEntry from 'lib/validator/isTimeEntry'

const validator = {
  notEmpty,
  notEmptyAttribute,
  minLength,
  isJSON,
  isEmail,
  isPhoneNumber,
  isTimeEntry,
}

export {
  notEmpty,
  notEmptyAttribute,
  minLength,
  isJSON,
  isEmail,
  isPhoneNumber,
  isTimeEntry,
  validator as default,
}
